import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import notFoundImage from '../assets/common/under-construction.svg';

export default function NotFoundPage() {
  return (
    <Stack alignItems='center' justifyContent='center' gap={6}>
      <div>
        <Typography
          component='h1'
          textAlign='center'
          sx={{ color: 'grey.500', fontWeight: 400, fontSize: '8.75rem' }}
        >
          404
        </Typography>
        <Typography
          component='h2'
          textAlign='center'
          sx={{ color: 'grey.500', fontSize: '3rem', fontWeight: 500 }}
        >
          oops! page not found
        </Typography>
        <Typography fontSize='1.5rem' textAlign='center' sx={{ color: 'grey.500' }}>
          This page is under construction and will be available soon
        </Typography>
      </div>
      <Box component='img' src={notFoundImage} alt='' sx={{ width: '100%', maxWidth: 640 }} />
    </Stack>
  );
}
